import { useContext, useState, useEffect } from 'react';
import { X, Check, Info, AlertTriangle } from 'lucide-react';
import NotificationContext, { type Notification } from '../../context/notification';

const icons = {
  success: Check,
  error: X,
  info: Info,
  warning: AlertTriangle,
};

const bgColors = {
  success: 'bg-primary',
  error: 'bg-destructive',
  info: 'bg-info',
  warning: 'bg-warning',
};

export function Notifications() {
  const { notifications, remove } = useContext(NotificationContext);
  return (
    <div className="fixed top-20 left-1/2 z-[60] flex -translate-x-1/2 flex-col gap-2">
      {notifications.map((n) => (
        <NotificationItem key={n.id} notification={n} onRemove={() => remove(n.id)} />
      ))}
    </div>
  );
}

function NotificationItem({ notification, onRemove }: { notification: Notification; onRemove: () => void }) {
  const [visible, setVisible] = useState(true);
  const Icon = icons[notification.type] || Info;
  const bg = bgColors[notification.type] || 'bg-info';

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 6000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm text-white shadow-2xl backdrop-blur-sm cursor-pointer transition-all duration-500 ${bg} ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}
      onClick={() => setVisible(false)}
      onTransitionEnd={() => { if (!visible) onRemove(); }}
    >
      <span>{notification.message}</span>
      <Icon className="size-4 shrink-0" />
    </div>
  );
}
